import { haveValue, shouldShowCapacityReport } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import ProfileRow from "./ProfileRow";

const ProfileTable = ({
  profile,
  properties,
  loadData,
  user,
  openAssignLLModal,
  checkSalary,
  rentPercentage,
  rentDoc,
  tenantChecks = false,
}) => {
  const { _t } = useTranslator();

  return (
    <>
      <div className="upcoming-box ">
        <table className="upcoming-table landlord-table bigtable_set">
          <caption className="skor-details d-none"></caption>
          <thead className="hideOnMobile">
            <tr className="first-row">
              <th style={{ width: "25%" }}> {_t("tenant")} </th>
              <th className="skor-details-column"> {_t("skor")} </th>
              <th> {_t("income")} </th>
              <th> {_t("maxRent", "Field in profile table")} </th>
              <th> {_t("flatmates")} </th>
              <th> {_t("guarantors")} </th>
              <th> {_t("linkedProperties", "Field in profile table")} </th>
              <th style={{ width: "16%" }}>
                {" "}
                {_t("infoUpdatedAt", "Field in profile table")}{" "}
              </th>
              <th style={{ width: "2%" }}></th>
            </tr>
          </thead>

          <tbody>
            {haveValue(profile)
              ? profile.map((data) => (
                  <ProfileRow
                    profile={data}
                    properties={properties}
                    loadData={loadData}
                    openAssignLLModal={openAssignLLModal}
                    checkSalary={checkSalary}
                    rentPercentage={rentPercentage}
                    rentDoc={rentDoc}
                    tenantChecks={tenantChecks}
                  />
                ))
              : _t("noDetailsFound")}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ProfileTable;
